import http from '@frontend/api/http';

export type EmailDomainResponse = {
  instance_id: string;
  email_domain: string;
  email_domain_verified: boolean;
  email_domain_updated_at: string;
  email_domain_updated_by: string;
};

export type UpdateEmailDomainRequest = {
  email_domain: string;
};

type GetEmailDomainParams = {
  instanceId: string;
};

type UpdateEmailDomainParams = {
  instanceId: string;
  email_domain: string;
};

export function getEmailDomain({ instanceId }: GetEmailDomainParams) {
  return Object.assign(
    async () => {
      return http
        .get<EmailDomainResponse>(`/hypatia/api/v1/instances/${instanceId}/email-domain`)
        .then(resp => resp.data);
    },
    { key: ['email-domain', instanceId] as const }
  );
}

export function updateEmailDomain({ instanceId, email_domain }: UpdateEmailDomainParams) {
  return http
    .put<EmailDomainResponse>(`/hypatia/api/v1/instances/${instanceId}/email-domain`, {
      email_domain,
    })
    .then(resp => resp.data);
}
